/**
 * OfflineProvider - Initialize offline sync system and provide global sync status
 */

import { useEffect } from "react";
import { useOfflineSync } from "@/hooks/useOfflineSync";
import { autoDownloadData } from "@/lib/offline/data-downloader";
import { initializeSyncManager } from "@/lib/sync/sync-manager";
import { OfflineIndicator } from "./offline/OfflineIndicator";
import { SyncStatus } from "./offline/SyncStatus";

export function OfflineProvider({ children }: { children: React.ReactNode }) {
  const { isOnline } = useOfflineSync();

  // Initialize sync manager on mount
  useEffect(() => {
    console.log("[OfflineProvider] Initializing offline sync system");
    initializeSyncManager();
  }, []);

  // Auto-download data when app loads or comes online
  useEffect(() => {
    if (isOnline) {
      console.log("[OfflineProvider] Device online, auto-downloading data...");
      autoDownloadData((progress) => {
        console.log(`[OfflineProvider] Download progress: ${progress.message}`);
      }).then((result) => {
        if (result.success) {
          console.log("[OfflineProvider] Auto-download complete:", {
            customers: result.customersCount,
            products: result.productsCount,
            services: result.servicesCount,
            projects: result.projectsCount,
          });
        } else {
          console.warn("[OfflineProvider] Auto-download failed:", result.error);
        }
      });
    }
  }, [isOnline]);

  return <>{children}</>;
}

export function GlobalOfflineIndicator() {
  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2">
      <OfflineIndicator />
      <SyncStatus showManualSync={true} />
    </div>
  );
}
